import request from '@/utils/request'

export default{

  downloadBillWxPay(billDate, type) {
    return request({
      url: '/public/api/wx-pay/downloadbill/' + billDate + '/' + type,
      method: 'get'
    })
  },

  downloadBillAliPay(billDate, type) {
    return request({
      url: '/public/api/ali-pay/bill/downloadurl/query/' + billDate + '/' + type,
      method: 'get'
    })
  },
  downloadBillWxPay1(billDate, type) {
    return request({
      url: '/public/api/wx-pay/downloadbill1/' + billDate + '/' + type,
      method: 'get'
    })
  },

  downloadBillAliPay1(billDate, type) {
    return request({
      url: '/public/api/ali-pay/bill/downloadurl/query1/' + billDate + '/' + type,
      method: 'get'
    })
  }
}
